import setting from '@/setting'
import { batchSaveTableConfig, getTableConfig } from '@/api/common/config'
import tableConfigs from '@/assets/config/table.json'
import { cloneDeep } from 'lodash'
import { useDbUtil } from './db'

/**
 * 设置表格配置参数
 * @param {Array} config 表格配置
 * @param {Array} originConfig 原始表格配置
 * @returns {Array} 表格配置
 */
const handleTableConfig = (config, originConfig) => {
  if (
    config.some(item => originConfig.findIndex(originItem => originItem.uId === item.uId) === -1) ||
    config.length !== originConfig.length
  ) {
    originConfig.forEach(item => {
      const target = config.find(childItem => item.uId === childItem.uId)
      if (target) {
        Object.keys(item).forEach(key => {
          if (target[key] !== undefined && target[key] !== null) {
            item[key] = target[key]
          }
        })
      }
    })
    return originConfig
  } else {
    return config
  }
}

export const useTableUtil = {
  /**
   * 获取表格序号
   * @param {number} page 当前页码
   * @param {number} rows 每页条数
   * @param {number} index 当前条数
   * @returns {number} 表格序号
   */
  number: (page, rows, index) => {
    return (page - 1) * rows + index + 1
  },

  /**
   * 保存表格配置
   * @param {string} type 表格类型
   * @param {Array} config 表格配置
   */
  async saveTableConfig(type, config) {
    try {
      useDbUtil.set(`${setting.name}-table-config-${type}`, JSON.stringify(config), true)
      await batchSaveTableConfig(type, config)
    } catch (error) {
      console.error(error)
    }
  },

  /**
   * 获取表格配置
   * @param {string} type 表格类型
   * @returns {Array} 表格配置
   */
  getTableConfig(type) {
    return cloneDeep(
      tableConfigs[type].map(item => ({
        uId: item[0] || '',
        name: item[1] || '',
        width: item[2] || '80',
        align: item[3] || 'center',
        color: item[4] || '',
        hide: item[5] || 0,
        fixed: item[6] || ''
      }))
    )
  },

  /**
   * 从缓存中获取表格配置
   * @param {string} type 表格类型
   * @param {Array} originConfig 原始表格配置
   * @returns {Array} 表格配置
   */
  getTableConfigCookie(type, originConfig) {
    const cookieConfig = useDbUtil.get(`${setting.name}-table-config-${type}`, '[]', true)
    const config = cookieConfig ? JSON.parse(cookieConfig) : []
    return handleTableConfig(config, originConfig)
  },

  /**
   * 请求表格配置
   * @param {string} type 表格类型
   * @param {Array} originConfig 原始表格配置
   * @returns {Promise} 表格配置
   */
  requestTableConfig(type, originConfig) {
    return new Promise((resolve, reject) => {
      getTableConfig(type)
        .then(res => {
          if (res.returnData && res.returnData.length > 0) {
            const config = handleTableConfig(res.returnData, originConfig)
            useDbUtil.set(`${setting.name}-table-config-${type}`, JSON.stringify(config), true)
            resolve(config)
          } else {
            reject(new Error('暂无表格配置'))
          }
        })
        .catch(error => reject(error))
    })
  },

  /**
   * 过滤表格配置参数
   * @param {Array} config 表格配置
   * @returns {Array} 表格配置
   */
  filterTableConfigParams(config) {
    return config.filter(item => item.hide === 0)
  }
}
